import { VueConstructor } from 'vue/types/vue'
import extend from 'quasar/src/utils/extend.js';

export function removeProps(mixin: VueConstructor<any>, props: string[]) {
  const mixinProps = extend(true, {}, (mixin as any).options.props as Record<string, any>)

  for (const prop of props) {
    delete mixinProps[prop]
  }

  (mixin as any).options.props = mixinProps

  return mixin
}
